export enum EntityStoreKey {
  conditions = 'conditions',
}

export interface ReferralsCondition {
  bodyHtml: string;
  id: number;
  position: number;
}
